import { onAddressChangedEvent } from '../../Shared/React/js/components/addressSearch/AddressSearch';

(function () {
    'use strict';

    async function main() {

        var searchPage = wo$('[data-search-page]');
        if (!searchPage.length) return;

        
        var searchController = {
            init: async function () {
                searchController.registerNotifications();
                searchController.initHistoryTracker();
                wo$('[data-enable-when-ready]').removeAttr('disabled');
                wo$('#add-a-line').remove();
                wo$('#numberOfLines').change(function () {
                    var url = wo$(this).val();
                    location.href = url;
                });
                WhistleOut.bindCitiesAutoComplete(searchPage);
                await WhistleOut.bindSlick();
                searchController.registerPlanTypeLinks();
                searchController.registerByodPicker();
                WhistleOut.getAds('MobilePhones');
            },

            registerByodPicker() {
                var supplierPage = wo$('#browse-provider-page');
                if (!supplierPage.length) return;

                supplierPage.find('[data-show-byod]').off('click').click(function() {
                    var byoModalContainer = wo$('#byo-modal-container');
                    if (byoModalContainer && byoModalContainer.length > 0) {
                        searchController.showByodPicker();
                    } else {
                        var siteConfiguration = WhistleOut.getSiteConfiguration();
                        wo$.ajax({
                            url: siteConfiguration.byoPhonePickerModalUrl,
                            type: 'GET',
                            success: function(result) {
                                if (result !== '') {
                                    if (!byoModalContainer || byoModalContainer.length < 1) {
                                        wo$('body').append('<div id="byo-modal-container"></div>');
                                        byoModalContainer = wo$('#byo-modal-container');
                                    }
                                    byoModalContainer.html(result);
                                    searchController.showByodPicker();
                                }
                            }
                        });
                    }
                });
            },

            showByodPicker: function() {

                WhistleOut.byoPhonePickerController.show(function(selectedModel) {
                    var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));

                    criteria.lines[0].phone = null;
                    criteria.lines[0].hasByodMatch = null;
                    criteria.lines[0].phoneManufacturer = null;
                    criteria.lines[0].simOnly = true;
                    criteria.lines[0].allowPhoneSub = false;
                    criteria.suppliers = [];
                    if (selectedModel) {
                        criteria.lines[0].byoPhoneModelId = selectedModel.selectedModelId;
                    } else {
                        criteria.lines[0].byoPhoneModelId = null;
                    }
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Lines', line: 0, criteria: criteria });
                });
            },

            registerPlanTypeLinks() {
                var supplierPage = wo$('#browse-provider-page');
                if (!supplierPage.length) return;

                supplierPage.find('[data-plan-type-link]').click(function () {
                    var tab = wo$(this).data('plan-type-link');
                    if (!tab) return;

                    var tabButton = wo$.find('[data-tab-button="' + tab + '"]')[0];
                    if (tabButton) {
                        WhistleOut.scrollTo(tabButton);
                        tabButton.click();
                    } else {
                        var tabLinkButton = wo$.find('[data-tab-linkbutton="' + tab + '"]')[0];
                        if (tabLinkButton) {
                            WhistleOut.scrollTo(wo$(tabLinkButton).closest('div.btn-group'));
                            tabLinkButton.click();
                        }
                    }
                });
            },

            registerNotifications: function () {
                WhistleOut.notifications.add(function (notification, data) {

                    if (data && data.criteria)
                        data.criteria.ShowAll = true;

                    if (notification === 'FilterChanged') {
                        var isAjax = data.type === 'Sort';
                        searchController.updateFilters(data.criteria, !isAjax);
                    }
                });

                addEventListener(onAddressChangedEvent, function (e) {
                    if (!e.detail) {
                        return;
                    }

                    var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                    criteria.address = e.detail.address == null ? null : e.detail.address.label;
                    searchController.updateFilters(criteria, true);
                });
            },

            trackPage: function (criteria) {
                var values = [];
                values.push(criteria.currentsupplierid > 0 ? criteria.currentsupplierid : null);
                values.push(criteria.minSpend > -1 ? criteria.minSpend : null);
                values.push(criteria.maxSpend > -1 ? criteria.maxSpend : null);
                values.push(criteria.lines.length === 1 ? criteria.lines[0].data : null);
                values.push(criteria.lines.length === 1 ? criteria.lines[0].calls ? criteria.lines[0].calls : criteria.lines[0].minutes : null);
                values.push(criteria.lines.length === 1 ? criteria.lines[0].sms : null);
                values.push(criteria.lines.length === 1 ? criteria.lines[0].phone : null);
                values.push(criteria.dealsonly);
                values.push(criteria.sortExpression);
                values.push(criteria.sortAscending);
                values.push(criteria.maxupfront > -1 ? criteria.maxupfront : null);
                var valuesString = values.join('|');
                WhistleOut.trackPageView(null, valuesString, true);
            },

            updateFilters: function (criteria, fullReload) {

                WhistleOut.startProgress('#search-results-partial', 0.1, 50);
                var queryString = '?';

                if (fullReload) {
                    criteria.hideEmptyTabs = false;
                    criteria.showAll = false;
                    criteria.showRowFilters = true;
                    criteria.hideWidenResults = false;
                    criteria.hideShare = false;
                    criteria.hideCoverage = false;
                    criteria.hideCoverageStrip = false;
                    criteria.maxResults = null;
                    criteria.maxResultsPerSupplier = null;
                    criteria.includefeatured = true;
                    criteria.enforceMaximumResultLimits = false;
                    criteria.productLabel = null;
                    searchController.trackPage(criteria);
                    queryString += WhistleOut.MobilePhones.generateQueryString(criteria);
                    location.href = criteria.searchUrl + queryString;
                    return;
                }

                queryString += WhistleOut.MobilePhones.generateQueryString(criteria);
                var resultsUrl = criteria.lines.length > 1 ? criteria.multiLineAjaxUrl : criteria.singleLineAjaxUrl;
                resultsUrl += queryString;

                wo$.ajax({
                    url: resultsUrl,
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#search-results-partial');
                        $results.html(result);

                        WhistleOut.applyPopover($results);

                        WhistleOut.endProgress();

                        WhistleOut.notifications.fire('SearchResultsRendered');

                        searchController.trackPage(criteria);

                        wo$(window).resize();

                        wo$('[data-enable-when-ready]').removeAttr('disabled');
                        wo$('#add-a-line').remove();
                    },
                    error: function () {
                        WhistleOut.endProgress();
                    }
                });
            },

            initHistoryTracker: function () {
                WhistleOut.initHistoryTracker(searchController);
            }
        };

        await searchController.init();
    };

    WhistleOut.initModule(import.meta.url, main);

}());